export default __webpack_public_path__ + "static/media/thumbs-up-disabled.5e50ccb9.svg";